import { parseISO, format } from 'date-fns';
import _isString from 'lodash/isString';

import { PARTNER_DASHBOARD_UNLOCK_CLASS_LEVEL_CAMPAIGNS } from 'components/Optimizely/Optimizely.features';
import { SERVER_DATE_FORMAT } from 'constants/logic';

export const CAMPAIGN_TYPE = {
  ALL_USER: 'ALL_USER',
  NEW_USER: 'NEW_USER',
  WINBACK: 'WINBACK',
};

export const CAMPAIGN_LEVEL = {
  CLASS: 'CLASS',
  VENUE: 'VENUE',
};

export const EDITABLE_CAMPAIGN_TYPES = [CAMPAIGN_TYPE.ALL_USER, CAMPAIGN_TYPE.NEW_USER, CAMPAIGN_TYPE.WINBACK];
export const EDITABLE_CAMPAIGN_LEVELS = [CAMPAIGN_LEVEL.VENUE, CAMPAIGN_LEVEL.CLASS];

export const PREFERRED_CAMPAIGN_ORDER = [CAMPAIGN_TYPE.NEW_USER, CAMPAIGN_TYPE.WINBACK, CAMPAIGN_TYPE.ALL_USER];

export const RECOMMENDED_CAMPAIGNS = [CAMPAIGN_TYPE.NEW_USER];

export function formatDate(date) {
  let datetime = date;
  if (_isString(date)) {
    datetime = parseISO(date);
  }
  return format(datetime, SERVER_DATE_FORMAT);
}

export function canCreateVenueLevel(campaign) {
  const { availableLevels } = campaign;
  return !!availableLevels.find(({ level, available }) => level === CAMPAIGN_LEVEL.VENUE && available);
}

export function canCreateClassLevel(campaign, isAppointmentTypeVenue) {
  const { availableLevels } = campaign;
  const fromBackend = !!availableLevels.find(({ level, available }) => level === CAMPAIGN_LEVEL.CLASS && available);

  const fromFeatureFlag = window[PARTNER_DASHBOARD_UNLOCK_CLASS_LEVEL_CAMPAIGNS];

  return fromBackend && (isAppointmentTypeVenue || fromFeatureFlag);
}

export function getDefaultDiscount(campaign) {
  const { availableLevels } = campaign;
  const venueLevel = availableLevels.find(({ level, available }) => level === CAMPAIGN_LEVEL.VENUE && available);
  const classLevel = availableLevels.find(({ level, available }) => level === CAMPAIGN_LEVEL.CLASS && available);

  return venueLevel?.defaultDiscount || classLevel?.defaultDiscount || 0;
}

export const discountOptions = (() => {
  const options = [];

  for (let i = 60; i >= 10; i -= 5) {
    options.push(i);
  }

  return options;
})();

export const isAvailable = campaign => campaign.availableLevels.find(level => level.available);
